import React from 'react';
import { Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { MerchantsDataTab } from './components/merchan-data-tab';
import { BranchesTab } from './components/BranchesTab';

export const Merchants = () => {

  return (
    <Flex flexDirection="column" height="100%" overflow="hidden">
      <Heading as="h2" fontSize="xl">Mi comercio</Heading>

      <Tabs display="flex" overflow="hidden" flexDirection="column" flexGrow="1" marginTop="xxl" colorScheme="orange" isLazy>
        <TabList flexWrap="wrap" flexShrink="0" backgroundColor="white">
          <Tab whiteSpace="nowrap">Datos de Mi comercio</Tab>
          <Tab whiteSpace="nowrap">Sucursales asociadas</Tab>
        </TabList>

        <TabPanels flexGrow="1" minHeight="0" overflowY="auto">
          <TabPanel height="100%">
            <MerchantsDataTab />
          </TabPanel>
          <TabPanel height="100%">
            <BranchesTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

const SectionHeading = ({ label }: { label: string }) => {
  return (
    <Heading as="h3"
             position="sticky"
             top="-3px"
             paddingY="l"
             borderBottomWidth="2px"
             borderBottomColor="grey.200"
             backgroundColor="white"
             zIndex="50"
             fontWeight="light"
             marginTop="xxl"
             marginBottom="xl"
             fontSize="xxl">
      {label}
    </Heading>
  );
};
